import { ExcelExportButton } from '@/components/common/ExcelExportButton';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export interface DashboardHeaderProps {
  title?: string;
  analysisDateText: string;
  totalLoansText: string;
  sourceText: string;
}

export function DashboardHeader(props: DashboardHeaderProps) {
  const {
    title = 'Portfolio Dashboard',
    analysisDateText,
    totalLoansText,
    sourceText,
  } = props;

  return (
    <div className="mb-8" data-test-id="dashboard-header">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1
            className="text-2xl font-bold mb-2"
            data-test-id="dashboard-title"
          >
            {title}
          </h1>
          <p className="section-subtitle" data-test-id="dashboard-subtitle">
            Analysis Date: {analysisDateText} | Total Loans: {totalLoansText} |
            Source: {sourceText}
          </p>
        </div>
        <div
          className="flex items-center gap-3"
          data-test-id="dashboard-actions"
        >
          <Link to="/loan-analytics">
            <Button variant="outline" data-test-id="risk-metrics-button">
              Risk Metrics
            </Button>
          </Link>
          <ExcelExportButton
            exportType="pricing-results"
            label="Export Pricing"
            variant="default"
          />
        </div>
      </div>
    </div>
  );
}
